export default "__VITE_ASSET__435133d0__"